import supabase from './supabase.json';

export default {
  supabase,
};
